const getEnvironment = () => {
  return {BASE_URL: process.env.REACT_APP_API_BASE_URL};
};

export const REPORTS_API_URL = process.env.REACT_APP_REPORTS_API_URL;
export const WEBSITE_URL=process.env.REACT_APP_WEBSITE_URL;
export const BASE_URL=process.env.REACT_APP_API_BASE_URL
export const DSA_API_URL = process.env.REACT_APP_DSA_API_URL;
export const DSA_X_API_KEY = process.env.REACT_APP_DSA_X_API_KEY;
export const DSA_X_API_SECRET = process.env.REACT_APP_DSA_X_API_SECRET;
export const DOWNLOAD_LOG_ACCESS_IDS =
  process.env.REACT_APP_DOWNLOAD_LOG_ACCESS_IDS ?? "[]";

export { getEnvironment };
